import { PowerUnit } from '@/entities/power-unit';

export function dynamicPowerUnit(w: number): PowerUnit {
  if (w === 0) return PowerUnit.W;

  const unit = Math.floor(Math.log10(Math.abs(w)) / 3);

  if (unit <= 0) return PowerUnit.W;
  if (unit === 1) return PowerUnit.KW;
  if (unit === 2) return PowerUnit.MW;
  if (unit === 3) return PowerUnit.GW;
  return PowerUnit.TW;
}
